'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Input", {
    enumerable: true,
    get: function() {
        return Input;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useInput = require("./useInput");
const _renderInput = require("./renderInput");
const _useInputStylesstyles = require("./useInputStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Input = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useInput.useInput_unstable)(props, ref);
    (0, _useInputStylesstyles.useInputStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useInputStyles_unstable')(state);
    return (0, _renderInput.renderInput_unstable)(state);
});
Input.displayName = 'Input';
